import classNames from 'classnames';
import { FC } from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div<{ $size: number }>`
  width: ${props => props.$size + 'rem'};
  height: ${props => props.$size + 'rem'};
`;

export const TinySpinner: FC<{ className?: string; size?: number }> = ({ className, size }) => (
  <>
    <StyledDiv $size={size ?? 1} className={classNames('spinner-border', className)} role="status"></StyledDiv>
    <span className="visually-hidden">Loading...</span>
  </>
);

TinySpinner.displayName = 'TinySpinner';
